import { type QueryHookOptions, useQuery } from "@apollo/client";
import {
  ContentPollsQuery,
  PollQuery,
  PollsListQuery,
} from "../graphql/queries";
import type {
  ContentPollsQueryType,
  ContentPollsQueryVariablesType,
  PollQueryType,
  PollQueryVariablesType,
  PollsListQueryType,
  PollsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const usePollsListQuery = (
  options?: QueryHookOptions<PollsListQueryType, PollsListQueryVariablesType>
) =>
  useQuery<PollsListQueryType, PollsListQueryVariablesType>(
    PollsListQuery,
    options
  );

export const usePollQuery = (
  options?: QueryHookOptions<PollQueryType, PollQueryVariablesType>
) => useQuery<PollQueryType, PollQueryVariablesType>(PollQuery, options);

export const useContentPollsQuery = (
  options?: QueryHookOptions<
    ContentPollsQueryType,
    ContentPollsQueryVariablesType
  >
) =>
  useQuery<ContentPollsQueryType, ContentPollsQueryVariablesType>(
    ContentPollsQuery,
    options
  );
